import { ref, onMounted, onUnmounted } from 'vue';

export function useIncomingCall() {
  const incomingCall = ref(null);
  const isConnecting = ref(false);

  // Helper to clear the popup
  const dismissCall = () => {
    incomingCall.value = null;
  };

  onMounted(() => {
    if (!window.Echo) {
      console.error('Laravel Echo is not configured.');
      return;
    }

    isConnecting.value = true;

    // Subscribe to the Private Channel
    window.Echo.private('agent-alerts')
      .listen('IncomingAiCallEvent', (e) => {
        console.log('🔔 AI Handoff Received:', e);

        // Update state with the payload from broadcastWith()
        incomingCall.value = {
          uuid: e.uuid,
          name: e.customer_name,
          intent: e.customer_intent,
          timestamp: e.timestamp
        };
      })
      .error((error) => {
        console.error('Echo connection error:', error);
        isConnecting.value = false;
      });
  });

  onUnmounted(() => {
    // Clean up listener to prevent memory leaks or duplicate alerts
    if (window.Echo) {
      window.Echo.private('agent-alerts').stopListening('IncomingAiCall');
    }
  });

  return {
    incomingCall,
    dismissCall
  };
}
